export default __webpack_public_path__ + "locales/vi/Common.json?hash=6e798296bb2a397dc1a2a8e78988552b";